module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "int"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "green"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_hd"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Most likely you already have a favorite cocktail. Maybe it’s the Margarita that brings back fond vacation memories, or the Old Fashioned your dad showed you how to make, or the Negroni a kind bartender introduced you to one evening.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("This book is about finding your next favorite cocktail, using the drinks you already know and love.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Each of the following chapters begins with a popular classic cocktail. You are encouraged to start with an old favorite and follow the thread in whatever direction interests you. On a single page, every drink will be similar to the classic cocktail in some way: one might swap out a single component (switching gin for bourbon changes a Negroni into a Boulevardier) or add an ingredient or two (putting bitters in a Gimlet transforms it into a Bennett). Others have similar flavor profiles (bitter, savory) or builds (a Scofflaw is just a couple of steps removed from a Manhattan). Find your usual go-to cocktail, and odds are there’s another drink in the same chapter you’ll enjoy just as much—or more.")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_c('a', {
    attrs: {
      "id": "pg7lev1"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("Dealer’s choice")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("If this all sounds a little familiar, possibly it’s because you’ve had this conversation with a bartender, often in the name of letting them select a “dealer’s choice” drink for you.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("I’ve had variations on the following negotiation dozens of times.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("BARTENDER:")])]), _vm._v(" What do you usually drink?")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("ME:")])]), _vm._v(" An Old Fashioned. But I wouldn’t mind something different.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("BARTENDER:")])]), _vm._v(" Do you feel like something refreshing [code for “not too strong”] or boozy?")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("ME:")])]), _vm._v(" Boozy, please.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("BARTENDER:")])]), _vm._v(" Any spirit or flavors in mind?")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("ME:")])]), _vm._v(" Well, I like smoky flavors.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("BARTENDER:")])]), _vm._v(" Got it. Leave it to me . . .")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v(". . . and a couple of pours and flourishes of citrus peel later, that conversation might lead to a Don Lockwood, an Old Fashioned variation made with maple syrup and peated Scotch (inside drink number 15), or perhaps a Penicillin, a gingery Whiskey Sour topped with a float of smoky Islay Scotch (inside drink number 13), set in front of me.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The point of this book is to allow you to follow a similar string of logic, from the comfort of your home bar. Start with a classic, and then go sweeter, stronger, smokier, etc. As the title of this book suggests, each drink is a twist—a variation—on a classic cocktail.")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "pg7lev9"
    }
  }), _vm._v("Find your next drink")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Each of the drinks in this book contains a bit of DNA from a classic cocktail. If your go-to is a Margarita, for example, all of the drinks in that section will be similar to a Margarita in some way.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The drinks in each chapter are based on flavor profiles and presentation, with very brief descriptors to help guide you to a drink you might enjoy next. Does the Scofflaw (whiskey + vermouth + grenadine + citrus) belong to the Manhattan family (whiskey + vermouth) or the Whiskey Sour family (whiskey + citrus + sweetener)? Instead of quibbling over the finer points of drink classification (boring), I’ve tried to stairstep from a classic Manhattan to drinks that are Manhattan-esque in some way.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Of note, there’s also plenty of what I’ve come to think of as “connective tissue” between the basic bones of various chapters. Wherever possible, I’ve tried to flag drinks that are related in some way, even if they’re elsewhere in the book. Jumping around from drink to drink and from chapter to chapter is highly encouraged.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("It’s my hope that you’ll be able to use this book to find your next favorite drink order—and to find maybe another favorite drink or two down the line after that as well.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5588ab06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05introduction.vue
// module id = 69
// module chunks = 0